import React from "react";

interface HamburgerMenuProps {
    onClick: () => void;
    visible: boolean;
    className?: string;
    style?: React.CSSProperties;
}

export const HamburgerMenu = (props: HamburgerMenuProps) => {
    if (!props.visible) return null;

    return (
        <div
            className={`header-burger position-absolute top-0 end-0 p-3 ${props.className || ""}`}
            style={props.style}
        >
            <button
                className="header-burger-btn burger"
                onClick={props.onClick}
                style={{
                    background: "none",
                    border: "none",
                    padding: "0.5rem",
                    cursor: "pointer",
                }}
                aria-label="Open menu"
            >
                <div className="burger-box">
                    <div className="burger-inner">
                        <div className="top-bun" />
                        <div className="patty" />
                        <div className="bottom-bun" />
                    </div>
                </div>
            </button>
        </div>
    );
};
